import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("ColibriToken");

export const CalculatorService = {
  async getCalculatorDeliveryType() {
    let response = await $axios
      .get($api("get_calculatorDeliveryType"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async calculateData(payload: any) {
    try {
      const response = await $axios.post($api("calculator"), payload, {
        headers: {
          "Accept-Language": "az",
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (err: any) {
      return err;
    }
  },
  async getCalculatorCountry(id: number | string) {
    try {
      const response = await $axios.get(
        $api("get_calculatorCountry", { country: id }),
        {
          headers: {
            "Accept-Language": "az",
          },
        }
      );
      return {
        data: response?.data || [],
        status: response?.status,
      };
    } catch (err: any) {
      console.error("getCalculatorCountry error:", err);
      return { data: [], status: err?.response?.status || 500 };
    }
  },
};
